export const lotSizeFaq = [
  {
    title: "calculator-suite.faq.forex.q1",
    texts: ["calculator-suite.faq.forex.a1"],
    icon: "monitoring",
  },
  {
    title: "calculator-suite.faq.forex.q2",
    texts: [
      "calculator-suite.faq.forex.a2-1",
      "calculator-suite.faq.forex.a2-2",
      "calculator-suite.faq.forex.a2-3",
    ],
    icon: "monitoring",
  },
  {
    title: "calculator-suite.faq.forex.q3",
    texts: ["calculator-suite.faq.forex.a3"],
    icon: "monitoring",
  },
];
export const masterFaq = [
  {
    title: "calculator-suite.faq.master.q1",
    texts: ["calculator-suite.faq.master.a1"],
    icon: "arrow_warm_up",
  },
  {
    title: "calculator-suite.faq.master.q2",
    texts: ["calculator-suite.faq.master.a2"],
    icon: "tactic",
  },
  {
    title: "calculator-suite.faq.master.q3",
    texts: [
      "calculator-suite.faq.master.a3-1",
      "calculator-suite.faq.master.a3-2",
    ],
    icon: "decimal_increase",
  },
];

export const fibonnaciFaq = [
  {
    title: "calculator-suite.faq.fibonacci.q1",
    texts: ["calculator-suite.faq.fibonacci.a1"],
    icon: "calculate",
  },
  {
    title: "calculator-suite.faq.fibonacci.q2",
    texts: ["calculator-suite.faq.fibonacci.a2"],
    icon: "earthquake",
  },
  {
    title: "calculator-suite.faq.fibonacci.q3",
    texts: ["calculator-suite.faq.fibonacci.a3"],
    icon: "search_insights",
  },
];

export const pivotFaq = [
  {
    title: "calculator-suite.faq.pivot.q1",
    texts: ["calculator-suite.faq.pivot.a1"],
    icon: "calculate",
  },
  {
    title: "calculator-suite.faq.pivot.q2",
    texts: ["calculator-suite.faq.pivot.a2"],
    icon: "earthquake",
  },
];
